<script setup>
import { onBeforeMount } from 'vue';
const emit = defineEmits(['getRecaptchaToken']);
let recaptchaWidget;

function injectRecaptcha() {
  if (document.getElementById('recaptcha-script')) {
    return;
  }

  const scriptTag = document.createElement('script');
  scriptTag.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
  scriptTag.id = 'recaptcha-script';

  scriptTag.onload = async function () {
    await grecaptcha.ready(function () {
      recaptchaWidget = grecaptcha.render(
        document.getElementById('g-recaptcha'),
        {
          sitekey: '6LelfMArAAAAALirEMLRB-Ywir9U2v7HjnxBLhp8',
        }
      );
    });
  };

  document.getElementsByTagName('head')[0].appendChild(scriptTag);
}

async function submit() {
  const reCaptchaValidation = await grecaptcha?.getResponse(recaptchaWidget);
  if (reCaptchaValidation?.length) {
    emit('getRecaptchaToken', reCaptchaValidation);
  } else {
    emit('getRecaptchaToken', null);
  }
}

async function resetCaptcha() {
  grecaptcha.reset();
}

onBeforeMount(() => {
  injectRecaptcha();
});

defineExpose({
  submit,
  resetCaptcha
});
</script>

<template>
  <div id="g-recaptcha"></div>
</template>
